// This icon file is generated automatically.
var DrrpDatafrmOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 40 40", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M37.5 11.88V3.12h-10v3.13h-10v12.5h-5v-3.13h-10v8.76h10v-3.13h5v12.5h10v3.13h10v-8.76h-10v3.13H20v-10h7.5v3.13h10v-8.75h-10v3.12H20v-10h7.5v3.13h10zm-27.5 10H5v-3.75h5v3.75zm20 8.75h5v3.75h-5v-3.76zm0-12.5h5v3.75h-5v-3.75zm0-12.5h5v3.75h-5V5.62z", "fill-rule": "nonzero" } }] }, "name": "drrp-datafrm", "theme": "outlined" };
export default DrrpDatafrmOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/DrrpDatafrmOutlined.js
// module id = 2549
// module chunks = 0